"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Column;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getContent = function getContent(content) {
  if (Array.isArray(content)) {
    return _react2.default.createElement(
      "ul",
      null,
      content.map(function (item, key) {
        return _react2.default.createElement("li", { key: key,
          dangerouslySetInnerHTML: {
            __html: item
          } });
      })
    );
  }

  return _react2.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: content
    }
  });
};

function Column(_ref) {
  var title = _ref.title,
      content = _ref.content;

  var contentString = getContent(content);
  return _react2.default.createElement(
    "div",
    { className: "column" },
    _react2.default.createElement(
      "h3",
      null,
      title
    ),
    contentString
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/Columns/Column.jsx
// module id = 1147
// module chunks = 0